import { Component } from '@angular/core';

@Component({
  selector: 'app-favorites-page-block',
  templateUrl: './favorites-page-block.component.html',
})
export class FavoritesPageBlockComponent {}
